module.exports = __webpack_public_path__ + "static/media/club.3c9d3a28.svg";